import URL from '../url'
import Request from '../request'

export const listApiKeysService = () => new Request(URL.API, URL.API_KEYS).get()

/**
 * Creates a key. The response carries the plaintext secret — it is the only time the server
 * returns it, so the caller must surface it to the user immediately.
 */
export const createApiKeyService = (data) =>
  new Request(URL.API, URL.API_KEYS).post(data)

export const revokeApiKeyService = (id) =>
  new Request(URL.API, URL.API_KEY_BY_ID.replace('{id}', id)).delete()
